// src/messaging/RequestsPanel.jsx
// 届いた申請（承認待ち）【2026-10-16】
//   参加したい（QR）・誘われた（学籍番号）・個別に話したい（グループのメンバーから）
//   ひとことはボタンの上に出す。承認 / 断る / 通報して断る / ブロック
import React, { useState } from 'react';
import { msgApi } from './api';
import { dateTime } from './util';
import { Modal, ReportDialog } from './ui';

function meaningText(r) {
  const from = r.from ? r.from.name : '（不明）';
  if (r.meaning === 'wants_to_join') {
    return r.group ? `${from}さんが、グループ「${r.group.title}」に参加したいそうです` : `${from}さんが、あなたと1対1のメッセージを始めたいそうです`;
  }
  if (r.meaning === 'wants_direct') {
    return `${from}さんが、あなたと個別にメッセージしたいそうです` + (r.via_group ? `（「${r.via_group.title || 'グループ'}」のメンバー）` : '');
  }
  return r.group ? `${from}さんが、あなたをグループ「${r.group.title}」に誘っています` : `${from}さんが、あなたを1対1のメッセージに誘っています`;
}

export default function RequestsPanel({ requests, onClose, onReload, onOpen }) {
  const [busyId, setBusyId] = useState(null);
  const [err, setErr] = useState('');
  const [info, setInfo] = useState('');
  const [reportFor, setReportFor] = useState(null);

  const act = async (r, fn) => {
    setBusyId(r.id); setErr(''); setInfo('');
    const res = await fn();
    setBusyId(null);
    if (!res.success) { setErr(res.message || 'うまくいきませんでした'); onReload(); return null; }
    onReload();
    return res;
  };

  const approve = async (r) => {
    const res = await act(r, () => msgApi.post(`/requests/${r.id}/approve`));
    if (res && res.conversation_id) { onClose(); onOpen(res.conversation_id); }
  };
  const decline = async (r) => {
    const res = await act(r, () => msgApi.post(`/requests/${r.id}/decline`));
    if (res) setInfo('断りました（相手には知らされません）');
  };
  const block = async (r) => {
    if (!window.confirm(`${r.from.name}さんをブロックしますか？\n相手には知らされません。この申請も取り下げられます。`)) return;
    const res = await act(r, () => msgApi.post('/blocks', { user_id: r.from.id }));
    if (res) setInfo(`${r.from.name}さんをブロックしました`);
  };

  return (
    <>
      <Modal title="届いた申請" onClose={onClose} wide>
        {err && <p className="msg-error">{err}</p>}
        {info && <p className="msg-help strong">{info}</p>}
        {requests === null && <p className="msg-help">読み込み中...</p>}
        {requests && requests.length === 0 && <p className="msg-help">承認待ちの申請はありません。</p>}
        <ul className="msg-request-list">
          {(requests || []).map(r => (
            <li key={r.id} className="msg-request">
              <p className="msg-request-what">{meaningText(r)}</p>
              <p className="msg-note-meta">{dateTime(r.created_at)}</p>
              {r.message && <p className="msg-request-note">{r.message}</p>}
              <div className="msg-row-buttons left">
                <button type="button" className="btn-primary" disabled={busyId === r.id} onClick={() => approve(r)}>承認</button>
                <button type="button" className="btn-secondary" disabled={busyId === r.id} onClick={() => decline(r)}>断る</button>
                <button type="button" className="btn-link danger" disabled={busyId === r.id} onClick={() => setReportFor(r)}>通報して断る</button>
                <button type="button" className="btn-link danger" disabled={busyId === r.id} onClick={() => block(r)}>ブロック</button>
              </div>
            </li>
          ))}
        </ul>
        <p className="msg-help">断っても相手には知らされません。申請は14日たつと消えます。</p>
      </Modal>
      {reportFor && (
        <ReportDialog target={{ request_id: reportFor.id }} what="この申請" onClose={() => setReportFor(null)}
                      onDone={(m) => { setInfo(m); onReload(); }} />
      )}
    </>
  );
}
